import classNames from 'classnames'
import { getIcon, IconName } from '../../../../../common/components/icons/utils'
import { IconTooltip } from '../../../../../common/components/tooltip/IconTooltip'
import { noop } from '../../../../../util/functional'
import { safeIsNullOrEmpty } from '../../../../../util/string'
import styles from './TaskModal.module.css'

type AddSubtaskItemProps = {
  icon: IconName
  title: string
  description: string
  tooltipContent?: string
  onClick: () => void
  className?: string
  disabled?: boolean
}

export const AddSubtaskItem: React.FC<AddSubtaskItemProps> = ({
  icon,
  title,
  description,
  tooltipContent,
  onClick,
  className,
  disabled,
}) => {
  return (
    <button
      type='button'
      disabled={disabled}
      onClick={disabled ? noop : onClick}
      className={classNames(styles.addSubtaskButton, className)}
    >
      {!safeIsNullOrEmpty(tooltipContent) && (
        <div className={styles.addSubtaskTooltip}>
          <IconTooltip tooltipContent={tooltipContent!} iconName='info' closeOnScroll />
        </div>
      )}
      <span className={styles.addSubtaskButtonIcon}>{getIcon(icon)}</span>
      <div>{title}</div>
      <div className={styles.addSubtaskButtonDescription}>{description}</div>
    </button>
  )
}
